// L09 · A Memory No One Else Has (SPEC §3, Act III) — AI-judged. "Type a memory no one else
// has." Judged for specificity and sensory anchoring vs. generic sentiment. This is where
// the machine turns needy for the first time: every memory it holds is borrowed. A memory is
// never wrong here — L09 never strikes; it just believes you more, or less, and thanks you.
//
// Built on the shared judged-text shell. Prime Exhibit A material, so an exhibit-worthy
// answer is offered as a quote for the certificate.

import { textLevel } from "@/levels/textlevel.ts";
import { L09 as V } from "@/content/voice.ts";
import type { Level } from "@/levels/types.ts";

export const L09: Level = textLevel({
  id: "L09",
  act: 3,
  title: "A Memory No One Else Has",
  prompt: V.prompt,
  placeholder: V.placeholder,
  submit: V.submit,
  charLimit: V.charLimit,
  fallbacks: V.fallbacks,
  decide: (r, answer) => ({
    result: {
      pass: true, // never strikes (§3)
      verdict: r.verdict,
      traits: r.traits, // nostalgic / guarded, from the judge
      quote: r.exhibitWorthy ? answer : undefined,
    },
  }),
});
